import { CommonModule, DatePipe, formatDate, isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatNativeDateModule, MAT_DATE_LOCALE, DateAdapter } from '@angular/material/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SelectionModel } from '@angular/cdk/collections';
import { Router } from '@angular/router';
import { EMPTY, Subscription, timer } from 'rxjs';
import { catchError, filter, switchMap } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { AlertCardComponent } from '@shared/components/alert-card/alert-card.component';
import { HeaderComponent } from '@shared/components/header/header.component';
import { EmptyListComponent } from '@shared/components/empty-list/empty-list.component';
import { LoadingBoxDefaultListComponent } from '@shared/components/loading-box-default-list/loading-box-default-list.component';
import { SelectPesquisavelComponent } from '@shared/components/select-pesquisavel/select-pesquisavel.component';
import { UiTagComponent } from '@shared/components/ui-tag/ui-tag.component';
import {
  ExtracaoDadosData,
  ExtracaoDadosModalComponent,
  FiltroExtracao,
} from '@shared/components/extracao-dados-modal/extracao-dados-modal.component';
import {
  ColunaConfiguracao,
  ConfiguracaoColunasModalComponent,
} from '@shared/components/configuracao-colunas-modal/configuracao-colunas-modal.component';
import { AlertService, AlertType } from '@shared/services/alert.service';
import { CustomDateAdapter } from '@shared/services/custom-date-adapter';
import { MaskService } from '@shared/services/mask.service';
import { UtilService } from '@shared/services/util.service';
import { MotorFiscalLookupService } from '@shared/services/apis/motor-fiscal/motor-fiscal-lookup.service';
import { NotaFiscalSaidaService } from '@shared/services/apis/orquestrador-vendas/nota-fiscal-saida.service';
import { AuthService } from '@shared/services/apis/usuario/auth.service';
import { TagNFeSaidaService } from '@shared/services/apis/repo-dfe/tag-nfe-saida.service';
import { NFeSaidaService } from '@shared/services/apis/repo-dfe/nfe-saida.service';
import { NotaFiscalSaidaListarRequest } from '@shared/services/requests/repo-dfe/nota-fiscal-saida-listar.request';
import { NotaFiscalSaidaListStruct } from '@shared/services/structs/repo-dfe/nota-fiscal-saida-list.struct';
import { NotaFiscalSaidaResumoStruct } from '@shared/services/structs/repo-dfe/nota-fiscal-saida-resumo.struct';
import { NotaFiscalSaidaLookupStruct } from '@shared/services/structs/repo-dfe/nota-fiscal-saida-lookup.struct';
import { AcaoNotaFiscalSaidaStruct } from '@shared/services/structs/repo-dfe/acao-nota-fiscal-saida.struct';
import { LookupItemStruct } from '@shared/services/structs/motor-fiscal/lookup-item.struct';
import { TagNFeSaidaResumoStruct } from '@shared/services/structs/repo-dfe/tag-nfe-saida-resumo.struct';
import { SituacaoNotaFiscalSaidaStruct } from '@shared/services/structs/orquestrador-vendas/situacao-nota-fiscal-saida.struct';
import { ConfirmModalComponent } from '@shared/components/confirm-modal/confirm-modal.component';
import {
  acoesNotaFiscalSaida,
  isStatusEditavelNFeSaida,
  motivoExclusaoIndisponivelNFeSaida,
} from '@shared/helpers/nota-fiscal-saida-acoes.helper';
import { PermissaoEnum } from '@shared/enums/usuario/permissao.enum';
import { classeBadgeStatusNFeSaida, iconeStatusNFeSaida } from '@shared/helpers/nota-fiscal-saida-status.helper';
import { ModuloEnum } from '@shared/enums/usuario/modulo.enum';
import { FuncionalidadeEnum } from '@shared/enums/usuario/funcionalidade.enum';
import { TipoOperacaoEnum } from '@shared/enums/motor-fiscal/tipo-operacao.enum';
import { AcaoNotaFiscalSaidaEnum } from '@shared/enums/vendas/acao-nota-fiscal-saida.enum';
import { PeriodoNotaFiscalSaidaEnum } from '@shared/enums/vendas/periodo-nota-fiscal-saida.enum';
import { StatusNFeSaidaEnum } from '@shared/enums/repo-dfe/status-nfe-saida.enum';
import { TipoIntegracaoEnum, TipoIntegracaoIndicador } from '@shared/enums/repo-dfe/tipo-integracao.enum';
import { ResumoNotaFiscalSaidaEnum } from '@shared/enums/vendas/resumo-nota-fiscal-saida.enum';
import { OrigemPedidoExportacaoEnum } from '@shared/enums/batch-extracao-dados/origem-pedido-exportacao.enum';
import { TipoExtracaoEnum } from '@shared/enums/batch-extracao-dados/tipo-extracao.enum';
import { AbntPipe } from '@shared/pipes/abnt.pipe';
import { CpfCnpjPipe } from '@shared/pipes/cpf-cnpj.pipe';
import { AlterarTagsNotaFiscalSaidaDialogComponent } from './dialogs/alterar-tags-nota-fiscal-saida-dialog/alterar-tags-nota-fiscal-saida-dialog.component';
import { AlterarTagsNotaFiscalSaidaDialogData } from './dialogs/alterar-tags-nota-fiscal-saida-dialog/alterar-tags-nota-fiscal-saida-dialog-data';
import { NotaFiscalSaidaImpressaoListaDialogComponent } from './dialogs/nota-fiscal-saida-impressao-lista-dialog/nota-fiscal-saida-impressao-lista-dialog.component';
import { NotaFiscalSaidaImpressaoListaDialogData } from './dialogs/nota-fiscal-saida-impressao-lista-dialog/nota-fiscal-saida-impressao-lista-dialog-data';
import {
  NfeHistoricoDialogComponent,
  NfeHistoricoDialogData,
} from '../nota-fiscal-saida-documento/components/nfe-historico-dialog/nfe-historico-dialog.component';
import {
  NfeTransmitirDialogComponent,
  NfeTransmitirDialogData,
  NfeTransmitirDialogResult,
} from '../nota-fiscal-saida-documento/components/nfe-transmitir-dialog/nfe-transmitir-dialog.component';
import { TransmitirLoteNotaFiscalSaidaDialogComponent } from './dialogs/transmitir-lote-nota-fiscal-saida-dialog/transmitir-lote-nota-fiscal-saida-dialog.component';
import {
  NfeLancarFinanceiroDialogComponent,
  NfeLancarFinanceiroDialogData,
} from '../nota-fiscal-saida-documento/components/nfe-lancar-financeiro-dialog/nfe-lancar-financeiro-dialog.component';
import {
  NfeExcluirFinanceiroDialogComponent,
  NfeExcluirFinanceiroDialogData,
} from '../nota-fiscal-saida-documento/components/nfe-excluir-financeiro-dialog/nfe-excluir-financeiro-dialog.component';
import {
  TransmitirLoteNotaFiscalSaidaDialogData,
  TransmitirLoteNotaFiscalSaidaDialogResult,
} from './dialogs/transmitir-lote-nota-fiscal-saida-dialog/transmitir-lote-nota-fiscal-saida-dialog-data';

/** Intervalo da atualização automática das notas Em transmissão (ms). */
const INTERVALO_ATUALIZACAO_SITUACAO = 15000;

@Component({
  selector: 'app-nota-fiscal-saida-lista',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    HeaderComponent,
    AlertCardComponent,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatCheckboxModule,
    MatSelectModule,
    MatSortModule,
    MatTableModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatBadgeModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDialogModule,
    MatDividerModule,
    EmptyListComponent,
    LoadingBoxDefaultListComponent,
    SelectPesquisavelComponent,
    UiTagComponent,
    DatePipe,
    AbntPipe,
    CpfCnpjPipe,
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    { provide: DateAdapter, useClass: CustomDateAdapter },
  ],
  templateUrl: './nota-fiscal-saida-lista.component.html',
  styleUrls: ['./nota-fiscal-saida-lista.component.css'],
})
export class NotaFiscalSaidaListaComponent implements OnInit, OnDestroy {
  readonly moduloEnum = ModuloEnum.Vendas;
  readonly funcionalidadeEnum = FuncionalidadeEnum.Vendas_NotasFiscais;
  readonly periodoEnum = PeriodoNotaFiscalSaidaEnum;
  readonly urlVendedor = environment.urlApiPessoa + 'Lookup/listVendedorSelect';
  readonly urlProduto = environment.urlApiProduto + 'Lookup/listProdutoSelect';
  readonly selection = new SelectionModel<NotaFiscalSaidaListStruct>(true, []);
  readonly dataSource = new MatTableDataSource<NotaFiscalSaidaListStruct>();
  readonly model = this.formBuilder.group({
    pesquisa: [''],
    status: [[] as number[]],
    vendedores: [[] as number[]],
    tags: [[] as number[]],
    produtos: [[] as number[]],
    series: [[] as number[]],
    finalidades: [[] as number[]],
    naturezas: [[] as number[]],
    dataDe: [null as Date | null],
    dataAte: [null as Date | null],
    resumoFiltro: [ResumoNotaFiscalSaidaEnum.Todas],
    periodoSelecionado: [PeriodoNotaFiscalSaidaEnum.Ultimos30Dias],
  });
  /** Cards de status: filtro rápido. Todas nasce selecionado e nunca fica nenhum card ativo. */
  readonly opcoesResumo = [
    {
      resumo: ResumoNotaFiscalSaidaEnum.Todas,
      rotulo: 'Todas',
      cor: 'card-filtro-cinza',
      subtexto: 'todas as notas do período',
    },
    {
      resumo: ResumoNotaFiscalSaidaEnum.Pendentes,
      rotulo: 'Aguardando transmissão',
      cor: 'card-filtro-amarelo',
      subtexto: 'a conferir e transmitir',
    },
    {
      resumo: ResumoNotaFiscalSaidaEnum.EmTransmissao,
      rotulo: 'Em transmissão',
      cor: 'card-filtro-azul',
      subtexto: 'enviadas, aguardando a SEFAZ',
    },
    {
      resumo: ResumoNotaFiscalSaidaEnum.Rejeitadas,
      rotulo: 'Rejeitada',
      cor: 'card-filtro-vermelho',
      subtexto: 'recusadas pela SEFAZ',
    },
    {
      resumo: ResumoNotaFiscalSaidaEnum.Canceladas,
      rotulo: 'Cancelada',
      cor: 'card-filtro-cinza',
      subtexto: 'canceladas na SEFAZ',
    },
    {
      resumo: ResumoNotaFiscalSaidaEnum.Autorizadas,
      rotulo: 'Autorizada',
      cor: 'card-filtro-verde',
      subtexto: 'autorizadas pela SEFAZ',
    },
  ];
  readonly opcoesPeriodo = [
    { periodo: PeriodoNotaFiscalSaidaEnum.Ultimos30Dias, rotulo: 'últimos 30 dias' },
    { periodo: PeriodoNotaFiscalSaidaEnum.DoDia, rotulo: 'do dia' },
    { periodo: PeriodoNotaFiscalSaidaEnum.DoMes, rotulo: 'do mês' },
    { periodo: PeriodoNotaFiscalSaidaEnum.DoIntervalo, rotulo: 'do intervalo' },
    { periodo: PeriodoNotaFiscalSaidaEnum.SemFiltro, rotulo: 'sem filtro' },
  ];
  /** Ordem e visibilidade das colunas do grid; select e ações ficam fixas nas pontas. */
  todosCampos: ColunaConfiguracao[] = [
    { def: 'select', label: 'Seleção', visible: true, fixed: true, pinnedStart: true },
    { def: 'numeroSerie', label: 'Nº / Série', visible: true, fixed: false },
    { def: 'dataEmissao', label: 'Data emissão', visible: true, fixed: false },
    { def: 'nomeFantasia', label: 'Nome fantasia', visible: true, fixed: false },
    { def: 'valorTotal', label: 'Valor total', visible: true, fixed: false },
    { def: 'tags', label: 'Tags', visible: false, fixed: false },
    { def: 'integracoes', label: 'Integrações', visible: true, fixed: false },
    { def: 'status', label: 'Status', visible: true, fixed: false },
    { def: 'acoes', label: 'Ações', visible: true, fixed: true, pinnedEnd: true },
  ];
  displayedColumns: string[] = [];

  resumo = new NotaFiscalSaidaResumoStruct();
  listaStatus: NotaFiscalSaidaLookupStruct[] = [];
  /** Séries vêm do response como números; o select pesquisável precisa de objetos. */
  listaSerie: { serie: number }[] = [];
  listaFinalidade: LookupItemStruct[] = [];
  listaNatureza: LookupItemStruct[] = [];
  listaTags: TagNFeSaidaResumoStruct[] = [];
  /** Nomes escolhidos nos selects por API, para exibir os filtros fora do select (exportação). */
  vendedores = new Map<number, string>();
  produtos = new Map<number, string>();
  acoesLinha: AcaoNotaFiscalSaidaStruct[] = [];
  /** Nota com ação de linha em andamento: o botão de ações dela mostra o spinner. */
  idNFeSaidaEmAcao: number | null = null;
  isLoading = false;
  ultimaPagina = false;
  fullListSize = 0;
  paginaAtual = 0;
  isMobileDrawerOpen = false;

  /** Atualização automática das notas Em transmissão (polling); cancelada no destroy. */
  private atualizacaoAutomatica: Subscription | null = null;

  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
    this.dataSource.sortingDataAccessor = (row, property): string | number => this.getSortValue(row, property);
  }

  constructor(
    private formBuilder: FormBuilder,
    private notaFiscalSaidaService: NotaFiscalSaidaService,
    private motorFiscalLookupService: MotorFiscalLookupService,
    private tagNFeSaidaService: TagNFeSaidaService,
    private nfeSaidaService: NFeSaidaService,
    private authService: AuthService,
    private alertService: AlertService,
    private utilService: UtilService,
    private dialog: MatDialog,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  ngOnInit(): void {
    this.atualizarColunasVisiveis();
    this.carregarLookups();
    this.carregarTags();
    this.restaurarFiltros();
    this.pesquisar(true);
    this.iniciarAtualizacaoAutomatica();
  }

  /** Os filtros só voltam ao retornar do documento da nota (rota da T06), como na listagem de entrada. */
  ngOnDestroy(): void {
    this.atualizacaoAutomatica?.unsubscribe();
    this.utilService.salvarFiltro(this.moduloEnum, this.funcionalidadeEnum, this.model, [
      '/vendas/nota-fiscal-saida/documento',
    ]);
  }

  /** resumoFiltro/periodoSelecionado vivem no form só para entrar na persistência de filtros do UtilService.salvarFiltro. */
  get resumoFiltro(): ResumoNotaFiscalSaidaEnum {
    return this.model.get('resumoFiltro')!.value ?? ResumoNotaFiscalSaidaEnum.Todas;
  }
  get periodoSelecionado(): PeriodoNotaFiscalSaidaEnum {
    return this.model.get('periodoSelecionado')!.value ?? PeriodoNotaFiscalSaidaEnum.Ultimos30Dias;
  }

  get periodoLabel(): string {
    return this.opcoesPeriodo.find(x => x.periodo === this.periodoSelecionado)?.rotulo ?? '';
  }

  get opcaoResumoAtual() {
    return this.opcoesResumo.find(x => x.resumo === this.resumoFiltro) ?? this.opcoesResumo[0];
  }

  get qtdFiltrosAvancados(): number {
    const value = this.model.getRawValue();
    return (
      (value.vendedores?.length ? 1 : 0) +
      (value.tags?.length ? 1 : 0) +
      (value.produtos?.length ? 1 : 0) +
      (value.series?.length ? 1 : 0) +
      (value.finalidades?.length ? 1 : 0) +
      (value.status?.length ? 1 : 0) +
      (value.naturezas?.length ? 1 : 0)
    );
  }

  private restaurarFiltros(): void {
    const filtroSalvo = this.utilService.obterFiltro(this.moduloEnum, this.funcionalidadeEnum);
    if (filtroSalvo) this.model.patchValue(filtroSalvo);
  }

  /** Lookups do MotorFiscal; status e séries vêm do próprio response da listagem. */
  private carregarLookups(): void {
    this.motorFiscalLookupService.getDominios().subscribe({
      next: response => (this.listaFinalidade = response.finalidades || []),
      error: () => this.alertService.show('Erro', 'Não foi possível carregar as finalidades.', AlertType.error),
    });
    this.motorFiscalLookupService.getNaturezaOperacaoLookup(TipoOperacaoEnum.Saida).subscribe({
      next: response => (this.listaNatureza = response || []),
      error: () =>
        this.alertService.show('Erro', 'Não foi possível carregar as naturezas de operação.', AlertType.error),
    });
  }

  private carregarTags(): void {
    this.tagNFeSaidaService.getLookup().subscribe({
      next: response => {
        if (!response.isError) this.listaTags = response.list || [];
      },
      error: () => this.alertService.show('Erro', 'Não foi possível carregar as tags.', AlertType.error),
    });
  }

  pesquisar(novaBusca: boolean): void {
    if (this.isLoading) return;
    if (novaBusca) {
      this.paginaAtual = 0;
      this.ultimaPagina = false;
      this.selection.clear();
      this.dataSource.data = [];
    }
    this.isLoading = true;
    this.notaFiscalSaidaService.listar(this.montarRequest(), this.paginaAtual).subscribe({
      next: response => {
        this.isLoading = false;
        if (response.isError) {
          this.alertService.show('Aviso', response.errorDescription, AlertType.warning);
          return;
        }
        this.resumo = response.resumo || new NotaFiscalSaidaResumoStruct();
        // Status e séries só vêm na página 0; no "Ver mais" ficam os da primeira página.
        if (response.listaStatus) this.listaStatus = response.listaStatus;
        if (response.listaSerie) this.listaSerie = response.listaSerie.map(serie => ({ serie }));
        this.dataSource.data = [...this.dataSource.data, ...(response.list || [])];
        this.fullListSize = response.fullListSize;
        this.ultimaPagina = this.dataSource.data.length >= response.fullListSize;
      },
      error: () => {
        this.isLoading = false;
      },
    });
  }

  private montarRequest(): NotaFiscalSaidaListarRequest {
    const value = this.model.getRawValue();
    const { dataDe, dataAte } = this.getPeriodo();
    const request = new NotaFiscalSaidaListarRequest();
    // Dia local sem fuso: o JSON de um Date sairia em UTC ("...Z") e a API monta a faixa pelo fuso da empresa.
    request.dataDe = dataDe ? formatDate(dataDe, 'yyyy-MM-dd', 'pt-BR') : null;
    request.dataAte = dataAte ? formatDate(dataAte, 'yyyy-MM-dd', 'pt-BR') : null;
    request.pesquisar = value.pesquisa?.trim() || null;
    request.listIdStatusNFeSaida = value.status?.length ? value.status : null;
    request.listIdVendedor = value.vendedores?.length ? value.vendedores : null;
    request.listIdTagNFeSaida = value.tags?.length ? value.tags : null;
    request.listIdProduto = value.produtos?.length ? value.produtos : null;
    request.listSerie = value.series?.length ? value.series : null;
    request.listIdFinalidadeNFe = value.finalidades?.length ? value.finalidades : null;
    request.listIdNatOp = value.naturezas?.length ? value.naturezas : null;
    request.idResumoFiltro = this.resumoFiltro;
    return request;
  }

  aplicarFiltros(): void {
    this.pesquisar(true);
  }

  limparFiltros(): void {
    this.model.patchValue({
      pesquisa: '',
      status: [],
      vendedores: [],
      tags: [],
      produtos: [],
      series: [],
      finalidades: [],
      naturezas: [],
      dataDe: null,
      dataAte: null,
      resumoFiltro: ResumoNotaFiscalSaidaEnum.Todas,
      periodoSelecionado: PeriodoNotaFiscalSaidaEnum.Ultimos30Dias,
    });
    this.pesquisar(true);
  }

  proximaPagina(): void {
    if (!this.ultimaPagina) {
      this.paginaAtual++;
      this.pesquisar(false);
    }
  }

  /** Link do aviso de denegadas: Status = Denegada nos filtros avançados, card Todas e nova pesquisa. */
  filtrarDenegadas(): void {
    this.model.patchValue({
      status: [StatusNFeSaidaEnum.Denegada],
      resumoFiltro: ResumoNotaFiscalSaidaEnum.Todas,
    });
    this.pesquisar(true);
  }

  /** Sem toggle: clicar no card ativo mantém ele ativo, para nunca ficar sem card selecionado. */
  selecionarResumo(resumo: ResumoNotaFiscalSaidaEnum): void {
    this.model.get('resumoFiltro')?.setValue(resumo);
    this.pesquisar(true);
  }

  valorResumo(resumo: ResumoNotaFiscalSaidaEnum): number {
    switch (resumo) {
      case ResumoNotaFiscalSaidaEnum.Pendentes:
        return this.resumo.pendentes || 0;
      case ResumoNotaFiscalSaidaEnum.EmTransmissao:
        return this.resumo.emTransmissao || 0;
      case ResumoNotaFiscalSaidaEnum.Rejeitadas:
        return this.resumo.rejeitadas || 0;
      case ResumoNotaFiscalSaidaEnum.Autorizadas:
        return this.resumo.autorizadas || 0;
      case ResumoNotaFiscalSaidaEnum.Canceladas:
        return this.resumo.canceladas || 0;
      default:
        return this.resumo.totalNotas || 0;
    }
  }

  toggleGavetaMobile(): void {
    this.isMobileDrawerOpen = !this.isMobileDrawerOpen;
  }
  fecharGavetaMobile(): void {
    this.isMobileDrawerOpen = false;
  }

  selecionarPeriodo(periodo: PeriodoNotaFiscalSaidaEnum, event: Event): void {
    this.model.get('periodoSelecionado')?.setValue(periodo);
    if (periodo === PeriodoNotaFiscalSaidaEnum.DoIntervalo) {
      event.stopPropagation();
      return;
    }
    this.pesquisar(true);
  }

  aplicarIntervalo(trigger: MatMenuTrigger): void {
    const value = this.model.getRawValue();
    if (!value.dataDe || !value.dataAte) {
      this.alertService.show('Aviso', 'Informe a data inicial e a data final do intervalo.', AlertType.warning);
      return;
    }
    trigger.closeMenu();
    this.pesquisar(true);
  }

  cancelarIntervalo(trigger: MatMenuTrigger): void {
    this.model.patchValue({
      periodoSelecionado: PeriodoNotaFiscalSaidaEnum.Ultimos30Dias,
      dataDe: null,
      dataAte: null,
    });
    trigger.closeMenu();
  }

  onDateInput(event: Event, controlName: string): void {
    MaskService.onDateInput(event, this.model.get(controlName));
  }

  onVendedoresChange(selecionados: { id: number; descricao: string }[]): void {
    for (const vendedor of selecionados || []) this.vendedores.set(vendedor.id, vendedor.descricao);
  }

  onProdutosChange(selecionados: { idProduto: number; descricao: string }[]): void {
    for (const produto of selecionados || []) this.produtos.set(produto.idProduto, produto.descricao);
  }

  configurarColunas(): void {
    this.dialog
      .open(ConfiguracaoColunasModalComponent, {
        maxWidth: '700px',
        data: { colunas: this.todosCampos },
      })
      .afterClosed()
      .subscribe((result: ColunaConfiguracao[]) => {
        if (!result) return;
        this.todosCampos = result;
        this.atualizarColunasVisiveis();
      });
  }

  private atualizarColunasVisiveis(): void {
    this.displayedColumns = this.todosCampos.filter(c => c.visible).map(c => c.def);
  }

  prepararAcoes(nota: NotaFiscalSaidaListStruct): void {
    this.acoesLinha = acoesNotaFiscalSaida(nota, this.podeInserir, this.podeTransmitir, this.podeExcluirFinanceiro);
  }

  /** Transmitir e o lote pedem a permissão de transmitir (só lista de permissões, como a API). */
  get podeTransmitir(): boolean {
    return this.authService.getUserInfos()?.listaPermissoes?.includes(PermissaoEnum.Vendas_NotasFiscais_Autorizar) ?? false;
  }

  /** Clonar nota abre uma nota nova e lançar o financeiro usa a mesma permissão de incluir (só lista de permissões, como a API). */
  private get podeInserir(): boolean {
    return this.authService.getUserInfos()?.listaPermissoes?.includes(PermissaoEnum.Vendas_NotasFiscais_Inserir) ?? false;
  }

  /** Excluir o financeiro lançado pela nota (só lista de permissões, como a API). */
  private get podeExcluirFinanceiro(): boolean {
    return this.authService.getUserInfos()?.listaPermissoes?.includes(PermissaoEnum.Vendas_NotasFiscais_ExcluirFinanceiro) ?? false;
  }

  /** Selecionadas que podem sair do Workspace: aguardando transmissão, rejeitadas ou com transmissão não realizada, sem estoque e financeiro lançados. */
  get notasExcluiveisSelecionadas(): NotaFiscalSaidaListStruct[] {
    return this.selection.selected.filter(nota => !motivoExclusaoIndisponivelNFeSaida(nota));
  }

  /**
   * Por que nenhuma das notas pode ser excluída; vazio quando ao menos uma pode. Uma nota diz o motivo
   * dela; várias dizem o que as impede: o status, o estoque e o financeiro lançados ou os dois.
   */
  motivoExclusaoIndisponivel(notas: NotaFiscalSaidaListStruct[] = this.selection.selected): string {
    if (notas.length === 1) return motivoExclusaoIndisponivelNFeSaida(notas[0]);
    if (notas.some(nota => !motivoExclusaoIndisponivelNFeSaida(nota))) return '';

    const editaveis = notas.filter(nota => isStatusEditavelNFeSaida(nota.idStatusNFeSaida, nota.possuiTransmissaoNaoRealizada)).length;

    if (!editaveis) return 'Nenhuma nota selecionada está aguardando transmissão, rejeitada ou com transmissão não realizada.';
    if (editaveis === notas.length) return 'Exclua o estoque e o financeiro lançados das notas selecionadas antes de excluí-las.';

    return 'Nenhuma nota selecionada pode ser excluída: as aguardando transmissão, rejeitadas ou com transmissão não realizada têm estoque ou financeiro lançado e as demais não estão nessa situação.';
  }

  executarAcao(acao: AcaoNotaFiscalSaidaStruct, nota: NotaFiscalSaidaListStruct): void {
    switch (acao.acao) {
      case AcaoNotaFiscalSaidaEnum.EditarNotaFiscal:
      case AcaoNotaFiscalSaidaEnum.VisualizarNotaFiscal:
        this.abrirNotaFiscal(nota);
        return;
      case AcaoNotaFiscalSaidaEnum.DownloadEspelho:
        this.baixarEspelho(nota);
        return;
      case AcaoNotaFiscalSaidaEnum.AlterarTags:
        this.alterarTags([nota]);
        return;
      case AcaoNotaFiscalSaidaEnum.VerHistorico:
        this.verHistorico(nota);
        return;
      case AcaoNotaFiscalSaidaEnum.ClonarNota:
        this.clonarNota(nota);
        return;
      case AcaoNotaFiscalSaidaEnum.ExcluirNota:
        this.excluirNotas([nota]);
        return;
      case AcaoNotaFiscalSaidaEnum.Transmitir:
        this.transmitirNota(nota);
        return;
      case AcaoNotaFiscalSaidaEnum.LancarFinanceiro:
        this.lancarFinanceiro(nota);
        return;
      case AcaoNotaFiscalSaidaEnum.ExcluirFinanceiro:
        this.excluirFinanceiro(nota);
        return;
    }
  }

  // ================================================================== financeiro (T19)

  /** "Lançar financeiro" da nota autorizada: lançou, a listagem recarrega (letra F e ações da linha). */
  lancarFinanceiro(nota: NotaFiscalSaidaListStruct): void {
    this.dialog
      .open<NfeLancarFinanceiroDialogComponent, NfeLancarFinanceiroDialogData, boolean>(NfeLancarFinanceiroDialogComponent, {
        width: '760px',
        maxWidth: '96vw',
        maxHeight: '90vh',
        autoFocus: false,
        data: { idNFeSaida: nota.idNFeSaida, rotuloDocumento: `NF-e ${this.numeroSerie(nota)}` },
      })
      .afterClosed()
      .subscribe(lancou => {
        if (lancou) this.pesquisar(true);
      });
  }

  /** "Excluir financeiro" com justificativa: excluiu, a listagem recarrega. */
  excluirFinanceiro(nota: NotaFiscalSaidaListStruct): void {
    this.dialog
      .open<NfeExcluirFinanceiroDialogComponent, NfeExcluirFinanceiroDialogData, boolean>(NfeExcluirFinanceiroDialogComponent, {
        width: '720px',
        maxWidth: '96vw',
        maxHeight: '90vh',
        autoFocus: false,
        data: { idNFeSaida: nota.idNFeSaida, rotuloDocumento: `NF-e ${this.numeroSerie(nota)}` },
      })
      .afterClosed()
      .subscribe(excluiu => {
        if (excluiu) this.pesquisar(true);
      });
  }

  // ================================================================== transmitir (T13 e T14)

  /**
   * Modal "Transmitir NF-e" pela linha: depois de fechado, a linha é atualizada pela situação (Em transmissão, ou a
   * pendência de transmissão gravada). Na recusa, "Corrigir" abre a nota.
   */
  transmitirNota(nota: NotaFiscalSaidaListStruct): void {
    this.dialog
      .open<NfeTransmitirDialogComponent, NfeTransmitirDialogData, NfeTransmitirDialogResult>(NfeTransmitirDialogComponent, {
        width: '560px',
        maxWidth: '96vw',
        autoFocus: false,
        disableClose: true,
        data: {
          idNFeSaida: nota.idNFeSaida,
          subtitulo: `NF-e ${this.numeroSerie(nota)} - ${this.nomeFantasia(nota)}`,
          isHomologacao: null,
          isDoDocumento: false,
        },
      })
      .afterClosed()
      .subscribe(resultado => {
        if (!resultado) return;
        if (resultado.errorCodeRecusa != null) {
          this.abrirNotaFiscal(nota);
          return;
        }
        this.atualizarSituacoes([nota.idNFeSaida]);
      });
  }

  /** Selecionadas que podem ir à SEFAZ: aguardando transmissão, rejeitadas ou com transmissão não realizada. */
  get notasTransmissiveisSelecionadas(): NotaFiscalSaidaListStruct[] {
    return this.selection.selected.filter(nota => isStatusEditavelNFeSaida(nota.idStatusNFeSaida, nota.possuiTransmissaoNaoRealizada));
  }

  /** Lote com as selecionadas: o servidor devolve as elegíveis e o motivo das que ficam fora. */
  transmitirSelecionadas(): void {
    if (!this.notasTransmissiveisSelecionadas.length) return;
    this.abrirLoteTransmissao({
      listaIdNFeSaida: this.selection.selected.map(nota => nota.idNFeSaida),
      isTodasAguardandoTransmissao: false,
    });
  }

  transmitirTodasAguardandoTransmissao(): void {
    this.abrirLoteTransmissao({ listaIdNFeSaida: [], isTodasAguardandoTransmissao: true });
  }

  /** Ao fechar, a listagem é recarregada; o "Corrigir" de uma nota não enviada abre a nota. */
  private abrirLoteTransmissao(data: TransmitirLoteNotaFiscalSaidaDialogData): void {
    this.dialog
      .open<TransmitirLoteNotaFiscalSaidaDialogComponent, TransmitirLoteNotaFiscalSaidaDialogData, TransmitirLoteNotaFiscalSaidaDialogResult>(
        TransmitirLoteNotaFiscalSaidaDialogComponent,
        {
          width: '640px',
          maxWidth: '96vw',
          autoFocus: false,
          disableClose: true,
          data,
        },
      )
      .afterClosed()
      .subscribe(resultado => {
        if (resultado?.idNFeSaidaCorrigir) {
          this.router.navigate(['/vendas/nota-fiscal-saida/documento', resultado.idNFeSaidaCorrigir]);
          return;
        }
        this.pesquisar(true);
      });
  }

  /** Notas da página Em transmissão aguardando o retorno (sem a pendência de transmissão, que espera o usuário). */
  private get idsEmTransmissao(): number[] {
    return this.dataSource.data
      .filter(nota => nota.idStatusNFeSaida === StatusNFeSaidaEnum.EmTransmissao && !nota.possuiTransmissaoNaoRealizada)
      .map(nota => nota.idNFeSaida);
  }

  /**
   * A cada 15 s, enquanto houver nota Em transmissão na página e a aba estiver visível, consulta a situação delas. Só no
   * navegador (no SSR o timer prenderia a renderização).
   */
  private iniciarAtualizacaoAutomatica(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    this.atualizacaoAutomatica = timer(INTERVALO_ATUALIZACAO_SITUACAO, INTERVALO_ATUALIZACAO_SITUACAO)
      .pipe(
        filter(() => document.visibilityState === 'visible' && this.idsEmTransmissao.length > 0),
        switchMap(() => this.notaFiscalSaidaService.listarSituacao(this.idsEmTransmissao).pipe(catchError(() => EMPTY))),
      )
      .subscribe(response => {
        if (!response.isError) this.aplicarSituacoes(response.listaSituacao ?? []);
      });
  }

  /** Situação de notas pontuais (depois de transmitir pela linha). */
  private atualizarSituacoes(listaIdNFeSaida: number[]): void {
    this.notaFiscalSaidaService.listarSituacao(listaIdNFeSaida).subscribe({
      next: response => {
        if (response.isError) {
          this.alertService.show('Aviso', response.errorDescription, AlertType.warning);
          return;
        }
        this.aplicarSituacoes(response.listaSituacao ?? []);
      },
      error: () => {
        this.alertService.show('Aviso', 'Não foi possível atualizar a situação da nota agora. Recarregue a listagem em alguns instantes.', AlertType.warning);
      },
    });
  }

  /**
   * Único ponto de atualização das linhas pela situação das notas: status, pendência de transmissão, chave e último
   * retorno da SEFAZ, com o aviso curto de autorizada ou rejeitada e o resumo recarregado quando algo muda. Hoje é
   * alimentado pelo polling e pela transmissão da linha; com o WebSocket (Frente W), o evento da nota chama este
   * mesmo método e o polling sai.
   */
  aplicarSituacoes(listaSituacao: SituacaoNotaFiscalSaidaStruct[]): void {
    let isAlterado = false;

    for (const situacao of listaSituacao) {
      const nota = this.dataSource.data.find(linha => linha.idNFeSaida === situacao.idNFeSaida);
      if (!nota) continue;

      const isStatusAlterado = nota.idStatusNFeSaida !== situacao.idStatusNFeSaida;
      if (!isStatusAlterado && nota.possuiTransmissaoNaoRealizada === situacao.possuiTransmissaoNaoRealizada) continue;

      nota.idStatusNFeSaida = situacao.idStatusNFeSaida;
      nota.possuiTransmissaoNaoRealizada = situacao.possuiTransmissaoNaoRealizada;
      nota.chaveAcesso = situacao.chaveAcesso;
      nota.ultimoRetornoSefaz = situacao.ultimoRetornoSefaz;
      isAlterado = true;

      if (!isStatusAlterado) continue;
      if (situacao.idStatusNFeSaida === StatusNFeSaidaEnum.Autorizada) {
        this.alertService.show('Sucesso', `NF-e ${nota.numero ?? ''} autorizada.`, AlertType.success);
      } else if (situacao.idStatusNFeSaida === StatusNFeSaidaEnum.Rejeitada) {
        this.alertService.show('Aviso', `NF-e ${nota.numero ?? ''} rejeitada.`, AlertType.warning);
      }
    }

    if (!isAlterado) return;
    this.dataSource.data = [...this.dataSource.data];
    this.recarregarResumo();
  }

  /** Os cards contam o filtro inteiro no servidor: só o resumo da primeira página, sem mexer nas linhas carregadas. */
  private recarregarResumo(): void {
    this.notaFiscalSaidaService.listar(this.montarRequest(), 0).subscribe({
      next: response => {
        if (response.isError) {
          this.alertService.show('Aviso', response.errorDescription, AlertType.warning);
          return;
        }
        if (response.resumo) this.resumo = response.resumo;
      },
      error: () => {
        this.alertService.show('Aviso', 'Não foi possível atualizar os totais da listagem agora. Recarregue a listagem em alguns instantes.', AlertType.warning);
      },
    });
  }

  /** Rejeitada: o último retorno da SEFAZ no tooltip do status. */
  tooltipStatus(nota: NotaFiscalSaidaListStruct): string {
    const retorno = nota.ultimoRetornoSefaz;
    if (nota.idStatusNFeSaida !== StatusNFeSaidaEnum.Rejeitada || !retorno) return '';
    const codigo = retorno.codigoRetornoSefaz != null ? `Rejeição ${retorno.codigoRetornoSefaz}: ` : '';
    return `${codigo}${retorno.mensagemRetornoSefaz ?? ''}`;
  }

  /** A cópia abre como nota nova no documento; nada é gravado até o usuário salvar. */
  public clonarNota(nota: NotaFiscalSaidaListStruct): void {
    this.router.navigate(['/vendas/nota-fiscal-saida/documento'], { queryParams: { origem: nota.idNFeSaida } });
  }

  /**
   * Exclui só as elegíveis (aguardando transmissão, rejeitadas ou com transmissão não realizada, sem estoque e financeiro lançados); no lote, a
   * confirmação diz quantas saem e quantas ficam. Depois, a orientação para inutilizar a numeração.
   */
  public excluirNotas(notas: NotaFiscalSaidaListStruct[] = this.selection.selected): void {
    if (!notas.length) return;

    const elegiveis = notas.filter(nota => !motivoExclusaoIndisponivelNFeSaida(nota));
    if (!elegiveis.length) {
      this.alertService.show('Aviso', this.motivoExclusaoIndisponivel(notas), AlertType.warning);
      return;
    }

    const isEmLote = notas.length > 1;
    const mantidas = notas.length - elegiveis.length;
    const quantidades = isEmLote
      ? ` ${elegiveis.length === 1 ? 'Será excluída 1 nota.' : `Serão excluídas ${elegiveis.length} notas.`}` +
        (mantidas === 1
          ? ' A outra selecionada fica, porque não está aguardando transmissão, rejeitada ou com transmissão não realizada, ou tem estoque ou financeiro lançado.'
          : mantidas > 1
            ? ` As outras ${mantidas} selecionadas ficam, porque não estão aguardando transmissão, rejeitadas ou com transmissão não realizada, ou têm estoque ou financeiro lançado.`
            : '')
      : '';

    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: '440px',
      maxWidth: '96vw',
      data: {
        title: isEmLote ? 'Excluir as notas?' : 'Excluir a nota?',
        description: isEmLote
          ? `A exclusão remove os registros do Workspace. Só é possível porque as notas nunca foram autorizadas.${quantidades}`
          : 'A exclusão remove o registro do Workspace. Só é possível porque a nota nunca foi autorizada.',
        buttonConfirm: 'Excluir',
        buttonClose: 'Cancelar',
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result?.confirm) return;

      const isUmaNota = elegiveis.length === 1;
      if (isUmaNota) this.idNFeSaidaEmAcao = elegiveis[0].idNFeSaida;
      this.notaFiscalSaidaService.excluirEmLote(elegiveis.map(nota => nota.idNFeSaida)).subscribe({
        next: response => {
          this.idNFeSaidaEmAcao = null;
          if (response.isError) {
            this.alertService.show('Aviso', response.errorDescription, AlertType.warning);
            return;
          }
          this.alertService.show(
            'Sucesso',
            isUmaNota ? 'Nota fiscal excluída.' : `${elegiveis.length} notas fiscais excluídas.`,
            AlertType.success
          );
          if (response.avisoDescricao) this.alertService.show('Aviso', response.avisoDescricao, AlertType.warning);
          this.selection.clear();
          this.pesquisar(true);
        },
        error: () => {
          this.idNFeSaidaEmAcao = null;
          this.alertService.show('Aviso', 'Não foi possível excluir a nota fiscal. Tente novamente em alguns instantes.', AlertType.warning);
        },
      });
    });
  }

  verHistorico(nota: NotaFiscalSaidaListStruct): void {
    this.dialog.open(NfeHistoricoDialogComponent, {
      width: '640px',
      maxWidth: '96vw',
      autoFocus: false,
      data: {
        idNFeSaida: nota.idNFeSaida,
        titulo: nota.numero != null ? `NF-e ${this.numeroSerie(nota)}` : 'Nota Fiscal Eletrônica',
      } as NfeHistoricoDialogData,
    });
  }

  /** Status editável abre o documento; os demais abrem a visualização (D38). */
  public abrirNotaFiscal(nota: NotaFiscalSaidaListStruct): void {
    if (isStatusEditavelNFeSaida(nota.idStatusNFeSaida, nota.possuiTransmissaoNaoRealizada)) {
      this.router.navigate(['/vendas/nota-fiscal-saida/documento', nota.idNFeSaida]);
      return;
    }
    this.router.navigate(['/vendas/nota-fiscal-saida/documento', nota.idNFeSaida, 'visualizar']);
  }

  public incluirNotaFiscal(): void {
    this.router.navigate(['/vendas/nota-fiscal-saida/documento']);
  }

  public alterarTags(notas: NotaFiscalSaidaListStruct[] = this.selection.selected): void {
    if (!notas.length) return;
    if (notas.some(nota => nota.idEmpresa !== this.authService.getUserInfos().idEmpresa)) {
      this.alertService.show(
        'Aviso',
        'As tags só podem ser alteradas para notas da empresa atual.',
        AlertType.warning
      );
      return;
    }
    const idsTagsAtuais = notas
      .map(nota => new Set((nota.tags || []).map(tag => tag.idTagNFeSaida)))
      .reduce((comuns, atuais) => new Set([...comuns].filter(id => atuais.has(id))));
    const dialogRef = this.dialog.open(AlterarTagsNotaFiscalSaidaDialogComponent, {
      width: '480px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      disableClose: true,
      data: {
        idsNFeSaida: notas.map(nota => nota.idNFeSaida),
        tags: this.listaTags,
        idsTagsAtuais: [...idsTagsAtuais],
      } as AlterarTagsNotaFiscalSaidaDialogData,
    });
    dialogRef.afterClosed().subscribe(atualizou => {
      if (atualizou) this.pesquisar(true);
    });
  }

  /** Pedido de extração com os filtros da listagem; com notas, só as selecionadas. */
  public exportar(notas: NotaFiscalSaidaListStruct[] | null = null): void {
    if (!notas?.length && !this.dataSource.data.length) {
      this.alertService.show('Aviso', 'Nada para exportar', AlertType.warning);
      return;
    }
    const value = this.model.getRawValue();
    const { dataDe, dataAte } = this.getPeriodo();
    const filtros: FiltroExtracao[] = [];
    filtros.push({
      label: 'Resumo da listagem',
      formControlName: 'idResumoFiltro',
      valor: this.resumoFiltro,
      valorExibicao: this.opcaoResumoAtual.rotulo,
    });
    if (dataDe)
      filtros.push({
        label: 'Data inicial',
        formControlName: 'dataDe',
        valor: formatDate(dataDe, 'yyyy-MM-dd', 'pt-BR'),
        valorExibicao: formatDate(dataDe, 'dd/MM/yyyy', 'pt-BR'),
      });
    if (dataAte)
      filtros.push({
        label: 'Data final',
        formControlName: 'dataAte',
        valor: formatDate(dataAte, 'yyyy-MM-dd', 'pt-BR'),
        valorExibicao: formatDate(dataAte, 'dd/MM/yyyy', 'pt-BR'),
      });
    if (value.pesquisa?.trim())
      filtros.push({ label: 'Pesquisa', formControlName: 'pesquisar', valor: value.pesquisa.trim() });
    if (value.status?.length)
      filtros.push({
        label: 'Status',
        formControlName: 'listIdStatusNFeSaida',
        valor: value.status,
        valorExibicao: value.status.map(id => this.listaStatus.find(x => x.id === id)?.nome ?? String(id)),
      });
    if (value.vendedores?.length)
      filtros.push({
        label: 'Vendedor',
        formControlName: 'listIdVendedor',
        valor: value.vendedores,
        valorExibicao: value.vendedores.map(id => this.vendedores.get(id) ?? String(id)),
      });
    if (value.tags?.length)
      filtros.push({
        label: 'Tags',
        formControlName: 'listIdTagNFeSaida',
        valor: value.tags,
        valorExibicao: value.tags.map(
          id => this.listaTags.find(tag => tag.idTagNFeSaida === id)?.descricao ?? String(id)
        ),
      });
    if (value.produtos?.length)
      filtros.push({
        label: 'Produto',
        formControlName: 'listIdProduto',
        valor: value.produtos,
        valorExibicao: value.produtos.map(id => this.produtos.get(id) ?? String(id)),
      });
    if (value.series?.length)
      filtros.push({
        label: 'Série',
        formControlName: 'listSerie',
        valor: value.series,
        valorExibicao: value.series.map(serie => String(serie)),
      });
    if (value.finalidades?.length)
      filtros.push({
        label: 'Finalidade',
        formControlName: 'listIdFinalidadeNFe',
        valor: value.finalidades,
        valorExibicao: value.finalidades.map(
          id => this.listaFinalidade.find(x => x.id === id)?.descricao ?? String(id)
        ),
      });
    if (value.naturezas?.length)
      filtros.push({
        label: 'Naturezas de operação',
        formControlName: 'listIdNatOp',
        valor: value.naturezas,
        valorExibicao: value.naturezas.map(id => this.listaNatureza.find(x => x.id === id)?.descricao ?? String(id)),
      });
    if (notas?.length)
      filtros.push({
        label: 'Notas selecionadas',
        formControlName: 'idsNFeSaida',
        valor: notas.map(nota => nota.idNFeSaida),
        valorExibicao: notas.map(nota => this.numeroSerie(nota)),
      });

    this.dialog.open(ExtracaoDadosModalComponent, {
      data: {
        titulo: 'Exportar notas fiscais de saída',
        tipoExtracao: TipoExtracaoEnum.NotasFiscaisSaidaCSV,
        origemPedidoExportacao: OrigemPedidoExportacaoEnum.VendasNotasFiscais,
        filtros,
        possuiAutomacao: false,
      } as ExtracaoDadosData,
      panelClass: 'extracao-dados-panel',
      width: '640px',
      maxWidth: '96vw',
      disableClose: true,
    });
  }

  /** CSV gerado no RepoDFe; o BOM garante a acentuação ao abrir no Excel. */
  baixarEspelho(nota: NotaFiscalSaidaListStruct): void {
    this.idNFeSaidaEmAcao = nota.idNFeSaida;
    this.nfeSaidaService.getEspelho(nota.idNFeSaida).subscribe({
      next: response => {
        this.idNFeSaidaEmAcao = null;
        if (response.isError) {
          this.alertService.show('Aviso', response.errorDescription, AlertType.warning);
          return;
        }
        const blob = new Blob(['﻿' + response.conteudoCsv], { type: 'text/csv;charset=utf-8' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = response.nomeArquivo;
        document.body.appendChild(a);
        a.click();
        a.remove();
        setTimeout(() => URL.revokeObjectURL(url), 1000);
        this.alertService.show(
          'Espelho da NF exportado',
          `${response.nomeArquivo} - ${response.quantidadeItens} ${response.quantidadeItens === 1 ? 'item' : 'itens'}`,
          AlertType.success
        );
      },
      error: () => {
        this.idNFeSaidaEmAcao = null;
        this.alertService.show('Erro', 'Não foi possível gerar o espelho da NF.', AlertType.error);
      },
    });
  }

  /** Prévia do relatório com os mesmos filtros da listagem, sem paginação. */
  imprimirRelatorio(): void {
    if (!this.dataSource.data.length) {
      this.alertService.show('Aviso', 'Nada para imprimir', AlertType.warning);
      return;
    }
    const { dataDe, dataAte } = this.getPeriodo();
    const rotuloPeriodo =
      dataDe && dataAte
        ? `Período de ${formatDate(dataDe, 'dd/MM/yyyy', 'pt-BR')} a ${formatDate(dataAte, 'dd/MM/yyyy', 'pt-BR')}`
        : 'Sem filtro de período';
    this.dialog.open(NotaFiscalSaidaImpressaoListaDialogComponent, {
      width: '1060px',
      maxWidth: '95vw',
      data: {
        filtro: this.montarRequest(),
        rotuloPeriodo,
        listaStatus: this.listaStatus,
      } as NotaFiscalSaidaImpressaoListaDialogData,
    });
  }

  /** Nota legada sem número, "-"; série e número andam juntos. */
  numeroSerie(nota: NotaFiscalSaidaListStruct): string {
    return nota.numero != null ? `${nota.numero}${nota.serie != null ? ` / ${nota.serie}` : ''}` : '-';
  }
  nomeFantasia(nota: NotaFiscalSaidaListStruct): string {
    return nota.nomeFantasiaDestinatario || nota.nomeDestinatario || '—';
  }
  status(nota: NotaFiscalSaidaListStruct): string {
    return this.listaStatus.find(x => x.id === nota.idStatusNFeSaida)?.nome || '—';
  }
  classeBadgeStatus(nota: NotaFiscalSaidaListStruct): string {
    return classeBadgeStatusNFeSaida(nota.idStatusNFeSaida);
  }
  iconeStatus(nota: NotaFiscalSaidaListStruct): string {
    return iconeStatusNFeSaida(nota.idStatusNFeSaida);
  }
  /** Indicadores da coluna Integrações: o vínculo V e depois as letras na ordem fixa (E, F), só quando lançadas. */
  integracoes(nota: NotaFiscalSaidaListStruct): { sigla: string; rotulo: string; cor: string }[] {
    const indicadores: { sigla: string; rotulo: string; cor: string }[] = [];
    if (nota.isOrigemVenda) indicadores.push({ sigla: 'V', rotulo: 'Vinculada à venda', cor: 'var(--indicador-cor-v)' });
    if (nota.isEstoqueLancado) {
      const estoque = TipoIntegracaoIndicador[TipoIntegracaoEnum.Estoque];
      indicadores.push({ sigla: estoque.sigla, rotulo: 'Estoque lançado', cor: estoque.cor });
    }
    if (nota.isFinanceiroLancado) {
      const financeiro = TipoIntegracaoIndicador[TipoIntegracaoEnum.Financeiro];
      indicadores.push({ sigla: financeiro.sigla, rotulo: 'Financeiro lançado', cor: financeiro.cor });
    }
    return indicadores;
  }

  isAllSelected(): boolean {
    return this.selection.selected.length === this.dataSource.data.length;
  }
  toggleAllRows(): void {
    this.isAllSelected() ? this.selection.clear() : this.selection.select(...this.dataSource.data);
  }

  /** Últimos 30 dias é o padrão; sem filtro não manda datas. */
  private getPeriodo(): { dataDe: Date | null; dataAte: Date | null } {
    const value = this.model.getRawValue();
    switch (this.periodoSelecionado) {
      case PeriodoNotaFiscalSaidaEnum.SemFiltro:
        return { dataDe: null, dataAte: null };
      case PeriodoNotaFiscalSaidaEnum.DoIntervalo:
        if (value.dataDe && value.dataAte) return { dataDe: value.dataDe, dataAte: value.dataAte };
        break;
    }

    const hoje = new Date();
    const dataDe = new Date(hoje);
    switch (this.periodoSelecionado) {
      case PeriodoNotaFiscalSaidaEnum.DoDia:
        break;
      case PeriodoNotaFiscalSaidaEnum.DoMes:
        dataDe.setDate(1);
        break;
      default:
        dataDe.setDate(hoje.getDate() - 29);
        break;
    }
    return { dataDe, dataAte: hoje };
  }

  private getSortValue(row: NotaFiscalSaidaListStruct, property: string): string | number {
    switch (property) {
      case 'numeroSerie':
        return row.numero ?? 0;
      case 'dataEmissao':
        return row.dataEmissao ? new Date(row.dataEmissao).getTime() : 0;
      case 'nomeFantasia':
        return this.nomeFantasia(row);
      case 'status':
        return this.status(row);
      case 'valorTotal':
        return row.valorTotal || 0;
      default:
        return '';
    }
  }
}
